import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectPresetsEditable = (store: StoreSchema) => store.functionalitiesPresets.functionalitiesPresetsEditable